import React, { Component } from "react";

class RB_ProductPrint extends Component {
	state = {};
	render() {
		let { data } = this.props;
		let aufPriesClass = "";
		let dataObj = {
			ProductMaterial: "",
			ProductName: "",
			ProductBuilder: "",
			ProductDesc: "",
			surcharge: 0,
		};
		if (data.choice.material) {
			dataObj.ProductMaterial = data.choice.material.label.de;
			dataObj.ProductName = data.choice.label.de;
			dataObj.ProductBuilder = data.choice.manufacturer.name;
			dataObj.ProductDesc = data.choice.description.de;
			dataObj.surcharge = data.choice.surcharge;
		}
		if (data.choice.surcharge != 0) {
			aufPriesClass = "RBuch-AufPreis";
		}
		// console.log(data);
		return (
			<div className="RBuch-Product-Print">
				<span className="RBuch-ObjectName-Print">{data.objLabel}</span>
				<img className="RBuch-ProductImage-Print" src={data.choice.image_url} />
				<div className="RBuch-ProductMiddle-Print">
					{/* {console.log(JJ)} */}
					<span className="RBuch-ProductMaterial-Print">
						{dataObj.ProductMaterial}
					</span>
					<span className="RBuch-ProductName-Print">{dataObj.ProductName}</span>
					<span className="RBuch-ProductBuilder-Print">
						Hersteller: {dataObj.ProductBuilder}
					</span>
					<span className="RBuch-ProductDesc-Print">{dataObj.ProductDesc}</span>
				</div>
				<div className={"RBuch-ProductRightCol-Print " + aufPriesClass}>
					<span>Aufpreis</span>
					<span>
						{dataObj.surcharge.toLocaleString("de-DE", {
							style: "currency",
							currency: "EUR",
							maximumFractionDigits: 2,
						})}
					</span>
				</div>
			</div>
		);
	}
}

export default RB_ProductPrint;
